/**
 * Returns a vehicle object if it has the matching vehicle property being passed in.
 * Note: intended for use on VLP only
 *
 * @param {string} name Property name containing value to be compared.
 * @param {string} value Value to compare against.
 * @returns {object}
 */
const findVehicleByProperty = (name, value, vehicles) =>
	vehicles ? vehicles.find((vehicle) => vehicle[name] === value) || {} : {};

export default findVehicleByProperty;
